;(function( $ ) {
    'use strict';

    // /*** DEBUGGING - use this to fake the location cookie
    //    function setCookie(cname, cvalue, exdays) {
    //        var d = new Date();
    //        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    //        var expires = "expires=" + d.toUTCString();
    //        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    //    }
    //
    //    setCookie('_pc_UserLocation', 'GBP', 1);

    // document.cookie = "_pc_UserLocation=AUD;expires=" + (()=>{let x=new Date(); x.setTime(x.getTime() + 86400000); return x.toUTCString();})() + ";path=/";

    //*** END DEBUGGING

    // Get Cookie

    function getCookie( cname ) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent( document.cookie );
        let ca = decodedCookie.split( ';' );
        for ( let i = 0; i < ca.length; i++ ) {
            let c = ca[ i ];
            while ( c.charAt( 0 ) === ' ' ) {
                c = c.substring( 1 );
            }
            if ( c.indexOf( name ) === 0 ) {
                return c.substring( name.length, c.length );
            }
        }
        return "";
    }

    function getLocation() {
        let location = getCookie( '_pc_UserLocation' );
        let price = $( '.book-course__price--' + location );
        let tax = $( '.book-course__tax .tax-required--' + location );

        if ( location === 'GBP' || location === 'USD' || location === 'EUR' || location === 'AUD' ) {
            price.show();
            tax.show();
            return location;
        }
        else {
            $( '.book-course__price--GBP' ).show();
            $( '.book-course__tax .tax-required--GBP' ).show();
            return 'GBP';
        }
    }

    // Get currency
    function getCurrency( location ) {

        switch ( location ) {
            case 'GBP':
                return '&#163;';
            case 'USD':
                return '&#36;';
            case 'EUR':
                return '&#8364;';
            case 'AUD':
                return 'A&#36;';
            default:
                return location;
        }
    }


    // Course Selector

    function disableUnselected( block ) {
        let unselected = $( block ).children( '.book-course__list' ).children( '.book-course__item' ).not( '[data-selected*="true"]' );
        let unselectedInputs = unselected.children( '.book-course__quantity' ).children();

        unselected.addClass( 'book-course__item--disabled' );
        unselectedInputs.each( function() {
            $( this ).attr( 'disabled', true );
        } );
    }

    function reEnable( block ) {
        let disabledItems = $( block ).children( '.book-course__list' ).children( '.book-course__item' ).not( '[data-selected*="true"]' );
        let disabledInputs = disabledItems.children( '.book-course__quantity' ).children();

        disabledItems.removeClass( 'book-course__item--disabled' );
        disabledInputs.each( function() {
            $( this ).removeAttr( 'disabled', true );
        } );
    }

    function buildHref( element, courseCode, date, volume, currency, taxRequired ) {
        let url = '/purchase?course=' + courseCode + '&date=' + date + '&volume=' + volume + '&currency=' + currency;
        if ( taxRequired !== undefined ) {
            url += '&GST=' + taxRequired;
        }

        element.attr( 'href', url );
    }

    function clearHref( element ) {
        element.attr( 'href', null );
    }

    function getSalesTaxText( location ) {
        switch ( location ) {
            case 'AUD':
                return '+GST';
            case 'EUR':
                return '+VAT';
            case 'GBP':
                return '+VAT';
            case 'USD':
                return '+VAT';
            default:
                return '+VAT';
        }
    }

    function courseValue( element, input ) {
        let location = getLocation();
        let parent = $( element ).closest( '.book-course' );
        let bookButton = parent.children( '.book-course__book' );
        let courseItem = $( element ).closest( '.book-course__item' );
        let courseCurrency = courseItem.children( '.book-course__details' ).children( '.book-course__price--' + location );
        let courseValue = courseCurrency.children( '.book-course__price--' + location + '-value' ).text();
        let totalValueDisplay = parent.children( 'div.book-course__total' ).children( 'div.book-course__total-value' );
        let totalValue = parseInt( courseValue ) * input.val();
        let courseCode = courseItem.attr( 'data-courseCode' );
        let dateCode = courseItem.attr( 'data-dateCode' );
        let taxRequired = (( node ) => {
            return node.length === 0 ? undefined : (node.is( ':checked' ) ? 'N' : 'Y');
        })( courseItem.children( '.book-course__tax' ).children( '.tax-required--' + location ).find( 'input[type=checkbox]' ) );

        if ( parseInt( courseValue ) * input.val() === 0 ) {
            totalValueDisplay.html( getCurrency( location ) + '0' ); // Want to show a zero value now
            courseItem.removeAttr( 'data-selected' );
            bookButton.attr( 'disabled', true );
            reEnable( parent );
            clearHref( bookButton );
        }
        else {
            totalValueDisplay.html( getCurrency( location ) + totalValue + '<span>' + getSalesTaxText( location ) + '</span>' );
            courseItem.attr( 'data-selected', true );
            bookButton.attr( 'disabled', false );
            disableUnselected( parent );
            buildHref( bookButton, courseCode, dateCode, input.val(), location, taxRequired );
        }
    }

    if ( $( '.book-course' ).length ) {

        // Event Listeners

        let minusButton = $( '.book-course__quantity .icon-minus' );
        let plusButton = $( '.book-course__quantity .icon-plus' );
        let countInput = $( '.book-course__quantity-input' );
        let removeButton = $( '.book-course__quantity-remove' );
        let taxRequired = $( '.book-course__tax [type=checkbox]' );
        let inputCount = 0;

        $( document ).ready( getLocation() );

        /* Use the first input to initialise the value field. */
        // plusButton.first().each(
        //     function () {
        //         let input = $(this).prev('.book-course__quantity-input');
        //         courseValue($(this), input);
        //     });

        plusButton.each(
            function() {
                let input = $( this ).prev( '.book-course__quantity-input' );
                courseValue( $( this ), input );
            } );

        taxRequired.on( 'change', function() {
            let input = $( this ).closest( '.book-course__tax' ).prev( '.book-course__quantity' ).children( '.book-course__quantity-input' );
            courseValue( $( this ), input );
        } );

        plusButton.on( 'click', function() {
            let input = $( this ).prev( '.book-course__quantity-input' );

            if ( input.val() < 5 ) {
                let inputCount = parseInt( input.val() ) + 1;
                input.val( inputCount );
                input.attr( 'value', inputCount );
                courseValue( $( this ), input );

                if ( inputCount === 5 ) {
                    $( this ).attr( 'disabled', true );
                }
            }
        } );

        minusButton.on( 'click', function() {
            let input = $( this ).next( '.book-course__quantity-input' );

            if ( input.val() > 0 ) {
                let inputCount = parseInt( input.val() ) - 1;
                input.val( inputCount );
                input.attr( 'value', inputCount );
                courseValue( $( this ), input );

                if ( inputCount < 5 ) {
                    let plusButton = input.next( '.icon-plus' );
                    plusButton.attr( 'disabled', false );
                }
            }
        } );

        countInput.on( 'keyup', function() {
            let input = $( this );
            let inputCount = parseInt( input.val() );
            let plusButton = input.next( '.icon-plus' );

            if ( inputCount <= 5 ) {
                input.val( inputCount );
                input.attr( 'value', inputCount );
                courseValue( $( this ), input );
            }
            else if ( inputCount > 5 ) {
                input.val( 5 );
                input.attr( 'value', 5 );
                courseValue( $( this ), input );
                plusButton.attr( 'disabled', true );
            }

            if ( inputCount === 5 ) {
                plusButton.attr( 'disabled', true );
            }
            else if ( inputCount < 5 ) {
                plusButton.attr( 'disabled', false );
            }

        } );

        removeButton.on( 'click', function() {
            let input = $( this ).siblings( '.book-course__quantity-input' );

            inputCount = 0;
            input.val( inputCount );
            input.attr( 'value', inputCount );

            courseValue( $( this ), input );
        } );
    }

}( jQuery ));
